import { buildApiUrl, withBusinessHeaders } from './apiConfig';

const RELEASINGS_API_URL =
  process.env.REACT_APP_RELEASINGS_API_URL || buildApiUrl('/releasings');

export async function fetchReleasingWorkspace() {
  const response = await requestReleasingApi(RELEASINGS_API_URL, {
    fallbackMessage: 'Unable to load releasing workspace right now.',
  });

  return response.json();
}

export async function createRelease(payload) {
  const response = await requestReleasingApi(RELEASINGS_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to save release right now.',
  });

  return response.json();
}

export async function reopenRelease(id) {
  const response = await requestReleasingApi(`${RELEASINGS_API_URL}/${id}/reopen`, {
    method: 'PATCH',
    fallbackMessage: 'Unable to reopen release right now.',
  });

  return response.json();
}

async function requestReleasingApi(url, options) {
  const { fallbackMessage, ...requestOptions } = options;
  let response;

  try {
    response = await fetch(url, {
      ...requestOptions,
      headers: withBusinessHeaders(requestOptions.headers),
    });
  } catch (error) {
    throw new Error(getNetworkErrorMessage(error, fallbackMessage));
  }

  if (!response.ok) {
    const errorPayload = await safeReadJson(response);
    throw new Error(errorPayload?.message || fallbackMessage);
  }

  return response;
}

function getNetworkErrorMessage(error, fallbackMessage) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You are offline right now. Please reconnect to continue.';
  }

  if (error instanceof TypeError) {
    return 'Unable to reach the server right now. Please check your connection or try again in a moment.';
  }

  return fallbackMessage;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
